export const DIMENSION_GRID = 10;
export const OFFSET_ITEM = 4;

export enum ItemState {
    "VISIBLE" = "VISIBLE",
    "APPEAR" = "APPEAR",
    "GHOST" = "GHOST",
    "SHAKE" = "SHAKE",
    "HIDE" = "HIDE",
    "DISAPEAR" = "DISAPEAR",
}